// src/fast-quote/page-history.ts

/**
 * Utility to update page history by sending a POST request to the API.
 * Uses vanilla JS fetch API.
 */
import { getCookie } from './../utils/cookie';

export function updatePageHistory(pageName: string) {
  let pagePath = window.location.pathname;
  // Initialize the page history object with the anonymous ID
  let pageHistory = {
    anonymousId: localStorage.getItem('anonymousID'),
    accessTime: new Date().toISOString(),
    gclid: getCookie('gclid'),
    email: localStorage.getItem('apiEmail'),
    contextCampaignMedium: getCookie('utm_medium'),
    initialReferrer: getCookie('utm_source') || 'direct',
    pagePath: pagePath,
    pageReferrer: document.referrer || 'direct',
    pageTitle: document.title,
    pageName: pageName
  };

  let JWT = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIzODE2OTg0Mjc1IiwibmFtZSI6IldlYnNpdGUgQVBJIFNlcnZpY2UifQ.gS86Zw6eAx7wVbulMRJYdgMxDZQ02PFpS175BEPjnvI";
  fetch("https://api-v2.stage.us.agorocarbon.com/website-data", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${JWT}`
    },
    body: JSON.stringify(pageHistory),
  })
    .then(response => response.json())
    .then(response => {
      console.log(response);
    })
    .catch(error => {
      console.error('Error:', error);
    });
}
